import { Box, SxProps, styled, Theme } from "@mui/material";
import {
    DataGrid,
    GridColDef,
    GridEventListener,
    GridPaginationModel,
    GridSortModel,
    gridClasses,
} from "@mui/x-data-grid";

import { LoadingOverlay, NoRowsOverlay } from "../GaiaGridOverlay";

const StyledDataGrid = styled(DataGrid)({
    border: 0,
    [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
        outline: "none",
    },
    [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
        outline: "none",
    },
    [`& .${gridClasses.columnSeparator}`]: {
        [`&:not(.${gridClasses["columnSeparator--resizable"]})`]: {
            display: "none",
        },
    },
    [`& .${gridClasses.columnHeader}`]: {
        background: "none",
    },
});

export type GaiaTableProps = {
    columns: GridColDef[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rows: readonly any[] | undefined;
    paginationModel?: GridPaginationModel;
    onPaginationModelChange?: (model: GridPaginationModel) => void;
    onRowClick?: GridEventListener<"rowClick">;
    sortModel?: GridSortModel;
    onSortModelChange?: (model: GridSortModel) => void;
    rowCount?: number;
    loading?: boolean;
    sx?: SxProps<Theme> | undefined;
};

export default function GaiaTable({
    columns,
    rowCount = undefined,
    rows = undefined,
    paginationModel = undefined,
    onPaginationModelChange = undefined,
    sortModel = undefined,
    onRowClick = undefined,
    onSortModelChange = undefined,
    loading = false,
    sx = undefined,
}: GaiaTableProps) {
    return (
        <Box sx={{ minHeight: 400, display: "flex", flexDirection: "column" }}>
            <StyledDataGrid
                sx={sx}
                columns={columns}
                rows={rows}
                loading={loading}
                slotProps={{
                    row: {
                        style: { position: "relative" },
                    },
                }}
                slots={{
                    noRowsOverlay: NoRowsOverlay,
                    noResultsOverlay: NoRowsOverlay,
                    loadingOverlay: LoadingOverlay,
                }}
                rowCount={rowCount}
                paginationModel={paginationModel}
                onPaginationModelChange={onPaginationModelChange}
                onRowClick={onRowClick}
                sortModel={sortModel}
                onSortModelChange={onSortModelChange}
                disableColumnResize
                paginationMode="server"
                sortingMode="server"
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnMenu
            />
        </Box>
    );
}
